import react, { useParams } from 'react-router-dom';
import EditPedido from './edit'
import { TestComponent } from './edit';
import { useEffect, useState } from 'react';

import { loadData as getConfigs } from '.';

const ExternalView = () => {

    const { id } = useParams();
    const [config, setConfigs] = useState({})

    useEffect(()=>{
        getConfigs(setConfigs, true, ()=>{})
    }, [])

    return (
        <>
            <EditPedido
                data={{ id: Number(id) }}
                nextOrder={0}
                handleClose={() => { }}
                reloadData={() => { }}
                configs={config.configs}
                viewOnly={true}
            />
        </>
    )
}

export default ExternalView